import * as React from 'react'
import { Box, styled } from '@mui/material'
import { Typography as MIUTypography } from '@mui/material'

const Typography = styled(MIUTypography)(props => ({
  fontFamily: 'var(--font-family)',
  fontStyle: 'normal',
  fontSize: '1em',
  fontWeight: props.istitle ? 700 : 450,
  lineHeight: '24px',
  color: props.istitle ? '#1B1C37' : '#6A6A6A',
  textAlign: 'center',
}))

const ContainerBox = ({
  wWidth,
  widthMin,
  defaultWidthMin,
  title,
  children,
  defaultWidth,
  ...rest
}) => {
  return (
    <Box
      sx={{
        widthMin,
        width:
          wWidth < defaultWidthMin ?? 400
            ? `calc(${wWidth}px - 50px)`
            : defaultWidth ?? `340px`,
        border: 'thin solid #00527A',
        ...rest,
      }}>
      <Typography
        sx={{
          fontWeight: 650,
          p: 1,
          color: '#fff',
          backgroundColor: 'var(--color-blue)',
          fontSize: '0.9em',
        }}>
        {title}
      </Typography>
      {children}
    </Box>
  )
}

export default ContainerBox
